// Author - Abhinav Acharya Tirumala Vinjamuri
export const backend_url = process.env.REACT_APP_ENV === 'production' ? process.env.REACT_APP_BACKEND_URL : 'http://localhost:8080';